import { render, staticRenderFns } from "./CourseTypeList.vue?vue&type=template&id=218e82a0&scoped=true&"
import script from "./CourseTypeList.vue?vue&type=script&lang=js&"
export * from "./CourseTypeList.vue?vue&type=script&lang=js&"
import style0 from "./CourseTypeList.vue?vue&type=style&index=0&id=218e82a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218e82a0",
  null
  
)

export default component.exports